import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyArhabKhzk27vfzRe5-8DH3Woc6OSWOE6E",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "cmfp-chitthi.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "cmfp-chitthi",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "cmfp-chitthi.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "782616771809",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:782616771809:web:d3de4215809dc796c48ba0",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
